import { useEffect, useRef, useState, useCallback } from "react";
import Onboard from "bnc-onboard";
import { Web3Provider } from "@ethersproject/providers";

import { useCurrentAccount } from "../contexts/currentAccount";
import { useCurrentWeb3Context } from "../contexts/currentWeb3Provider";
import { fetcher, addNetwork } from "../utils/addChain";

const wallets = [{ walletName: "metamask", preferred: true }];

export const networks = {
  avalanche: {
    fuji: 43113,
  },
  ethereum: {
    mainnet: 1,
  },
  polygon: {
    mainnet: 137,
    mumbai: 80001,
  },
  fantom: {
    mainnet: 250,
  },
};

export const useAuthWallet = () => {
  const onboardStateRef = useRef(null);
  const { dispatchAccount } = useCurrentAccount();
  const { dispatchWeb3Instance } = useCurrentWeb3Context();
  const [chain, setChain] = useState({});

  const fetchChains = useCallback(async () => {
    const chains = await fetcher("https://chainid.network/chains.json");
    setChain(chains.find((chain) => chain.chainId === networks.polygon.mumbai));
    return chains;
  }, []);

  useEffect(() => {
    fetchChains();
  }, [fetchChains]);

  useEffect(() => {
    onboardStateRef.current = Onboard({
      // dappId: process.env.REACT_APP_BLOCKNATIVE_API_KEY,
      networkId: networks.polygon.mumbai,
      subscriptions: {
        wallet: (wallet) => {
          if (wallet.provider) {
            const web3Instance = new Web3Provider(wallet.provider);
            dispatchWeb3Instance({
              type: "SAVE_WEB3_INSTANCE",
              data: { web3Instance, walletProvider: wallet.provider },
            });
          } else {
            dispatchWeb3Instance({ type: "SAVE_WEB3_INSTANCE", data: null });
          }
        },
        address: (address) => {
          dispatchAccount({ type: "SAVE_ACCOUNT", data: address });
        },
      },
      walletSelect: {
        heading: "Select a wallet",
        description: "",
        wallets,
      },
    });

    const login = async () => {
      const previouslySelectedWallet =
        window.localStorage.getItem("selectedWallet");
      if (previouslySelectedWallet != null && onboardStateRef.current) {
        await onboardStateRef.current.walletSelect(previouslySelectedWallet);
        await onboardStateRef.current.walletCheck();
      }
    };

    login();
  }, [dispatchWeb3Instance, dispatchAccount]);

  const logout = () => {
    if (onboardStateRef.current) {
      onboardStateRef.current.walletReset();
      window.localStorage.removeItem("selectedWallet");
    }
  };

  const openWalletModal = async () => {
    const provider = new Web3Provider(window.ethereum, "any");
    await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();
    let userAddress = await signer.getAddress();
    addNetwork(userAddress, chain);
    if (onboardStateRef.current) {
      const readyToSelect = await onboardStateRef.current.walletSelect();
      const readyToTransact = await onboardStateRef.current.walletCheck();
      await onboardStateRef.current.accountSelect();
      const currentState = onboardStateRef.current.getState();
      if (!readyToSelect || !readyToTransact) {
        logout();
      } else if (readyToSelect && readyToTransact && currentState.wallet.name) {
        window.localStorage.setItem("selectedWallet", currentState.wallet.name);
      }
    }
  };

  return {
    openWalletModal,
    logout,
  };
};
